$(function(){
  var $ms = $(".tag-multiselect");

  $ms.each(function () {
    var $this = $(this);
  
    // Get currently selected tags
    var currentTags = $this.data("current-tags");

    // Get current tag context
    var tagContext = $this.data("tag-context");
    
    var dataSource = new kendo.data.DataSource({
      requestEnd: function (e) {
        var widget = $this.getKendoMultiSelect();
        var dataSource = e.sender;
  
        if (e.type === "create") {
          var newValue = e.response[0].ProductID;
  
          dataSource.one("sync", function () {
              widget.value(widget.value().concat([newValue]));
          });
        }
      },

      transport: {
        read:  {
          url: "/tags?context=" + tagContext,
          dataType: "json"
        },
      },
    });
  
    $this.kendoMultiSelect({
      filter: "contains",
      dataSource: dataSource,
      dataTextField: "name",
      dataValueField: "name",
      value: currentTags,
      noDataTemplate: $("#noDataTemplate").html(),
    });
  
    // Find the parent node for the no-data part of the page
    // id == id of multiselect tag + "-list"
    var $nodata = $("#" + $this[0].id + "-list").find(".k-no-data")

    // For adding new tags, this only adds to the text that's submitted
    // New tags aren't saved until the record is created/updated
    $nodata.on("click", "button", function(e){
      var mswidget = $this.getKendoMultiSelect();
      var value = $nodata.find("button").data("value");
      if (confirm("Are you sure?")) {
        mswidget.dataSource.add({
            name: value,
        });
        mswidget.value(mswidget.value().concat([value]));
      }
    });
  });
});